<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const USERS = 'get_users.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'conclusionUsers',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		props: {
			conc_id: false
		},
		methods: {
			change () {
				EventBus.$emit(`conclusion_user`, this.selected)
			}
		},
		created () {
			if (typeof this.conc_id !== 'undefined' && this.conc_id !== null && this.conc_id) {
				fetch(DB + USERS, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = data
						this.selected = this.conc_id
					}
					else {
						this.options = []
					}
				})
				.catch(err => console.log(err))
			}
		}
	}
</script>


// WEBPACK FOOTER //
// conclusionUser.vue?0bdf07dd